import { Controller } from "react-hook-form";
import { Grid, TextField, Typography } from "@mui/material";
import { IFormField } from "models/app";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { formatToday } from "helpers/utils";
interface Props extends IFormField {
  errors: any;
  control: any;
  required?: boolean;
  defaultValue?: any;
  onChange?: (e: any) => void;
  onReset?: (e: any) => void;
  grid?: number;
  watch?: any;
}

const RHCalender: React.FC<Props> = ({
  label,
  name,
  type,
  placeholder,
  disabled,
  autoFocus,
  control,
  errors,
  required,
  defaultValue,
  hidden,
  endAdornment,
  startAdornment,
  onChange,
  helperText,
  watch,
  isHorizontal,
  yearsOnly,
  hideLabel
}) => {

  const handleChange = (e: any) => onChange && onChange(e);

  return (
    <Grid display={hidden ? "none" : "block"}>
      <Grid container alignItems={"center"} hidden={hidden}>
        {!hideLabel && <Grid
          item
          xs={12}
          md={label ? (!isHorizontal ? 12 : 2) : 12}
          display={"flex"}
          justifyContent={"space-between"}
        >
          {label && (
            <Typography
              variant="body2"
              fontWeight={600}
              textAlign={"start"}
              minWidth={"16ch"}
            >
              {label}
            </Typography>
          )}
        </Grid>}
        <Grid item xs={12} md={label ? (!isHorizontal ? 12 : 10) : 12}>
        <Controller
          control={control}
          defaultValue={defaultValue || formatToday()}
          name={name}
          render={({ field: { onChange, value, ...field } }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
            <DesktopDatePicker
              disabled={disabled}
              views={yearsOnly ? ["year"] : ["year", "month", "day"]}
              openTo={yearsOnly ? "year" : "day"}
              label={hideLabel && label}
              inputFormat="DD-MM-YYYY"
              value={value ? dayjs(value, "DD-MM-YYYY") : null}
              onChange={(newValue) => {
                // Always store plain string in DD/MM/YYYY format
                const formatted = newValue ? dayjs(newValue).format("DD-MM-YYYY") : "";
                onChange(formatted);
                if (handleChange) handleChange(formatted);
              }}
        renderInput={(params) => (
          <TextField
            {...params}
            {...field}
            value={value || ""}
            error={!!errors[name]}
            helperText={errors[name] ? errors[name].message : helperText}
            onKeyDown={(e) => e.preventDefault()}
            fullWidth
            size="small"
            sx={{
              "& .MuiInputBase-root": {
                borderRadius: 1,
                px: 2,
                bgcolor: "common.white",
                height: 50,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  )}
/>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RHCalender;
